import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SOLUTIONS, waLink } from "../data/site";

const SolutionCard = ({ s, i }) => (
  <motion.a
    href={waLink(`Olá, Alfa Gráfica Digital! Gostaria de saber mais sobre *${s.title}*.`)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`solution-${s.id}`}
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    className="group flex gap-4 sm:gap-5 items-center bg-paper border border-ink/10 hover:border-alga p-3 sm:p-4 transition-colors duration-300"
  >
    <span className="relative h-24 w-24 sm:h-28 sm:w-28 shrink-0 rounded-full overflow-hidden bg-paper-2">
      <img src={s.img} alt={s.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
    </span>
    <span className="flex-1 min-w-0">
      <span className="flex items-center justify-between gap-2">
        <span className="font-display uppercase text-base sm:text-lg leading-tight">{s.title}</span>
        <ArrowUpRight className="h-5 w-5 shrink-0 text-alga transition-transform duration-500 group-hover:rotate-45" />
      </span>
      <span className="mt-1.5 block text-xs sm:text-sm text-ink-soft leading-snug">{s.desc}</span>
    </span>
  </motion.a>
);

export const Solutions = () => (
  <section id="solucoes" data-testid="solutions-section" className="px-5 sm:px-10 py-20 lg:py-28">
    <div className="mb-10">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink-soft">( Categorias )</p>
      <h2 className="mt-4 font-display uppercase text-4xl sm:text-6xl leading-[0.95]">Soluções para<br /><em className="text-alga">sua empresa</em>.</h2>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-5">
      {SOLUTIONS.map((s, i) => <SolutionCard key={s.id} s={s} i={i} />)}
    </div>
  </section>
);
